import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseProduct4() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validateGroup(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      productCount: isEmpty(state.productCount),
    };

    setter(errorState);

    if (errorState.title || errorState.productCount) {
      enqueueSnackbar("اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }
  function validate2(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      // productCount: isEmpty(state.productCount),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("عنوان را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validate(state, setter) {
    let errorState = {
      type: isEmpty(state.type),
      filter: isEmpty(state.filter),
      categoryID: isEmpty(state.categoryID),
      groupID: isEmpty(state.groupID),
      brandID: isEmpty(state.brandID),
    };

    setter(errorState);

    if (errorState.type || errorState.filter) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 1 && errorState.categoryID) {
      enqueueSnackbar("لطفا نوع دسته را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 2 && errorState.brandID) {
      enqueueSnackbar("لطفا برند را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 3 && errorState.groupID) {
      enqueueSnackbar("لطفا گروه را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const ProductOffer = (OfferID, callback) => {
    MyAxios.get(`Admin_HomeOfferGroup`, {
      headers: {
        AID: OfferID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateProductOffer = (state, image1, image2, background, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (image1) {
      data.append("image1", image1);
    }
    if (image2) {
      data.append("image2", image2);
    }
    if (background) {
      data.append("background", background);
    }
    MyAxios.put(`Admin_HomeOfferGroup`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddProductOffer = (state, image1, image2, background, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (image1) {
      data.append("image1", image1);
    }
    if (image2) {
      data.append("image2", image2);
    }
    if (background) {
      data.append("background", background);
    }
    MyAxios.post(`Admin_HomeOfferGroup`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  //   /////////////////////////////////////// AddProduct ////////////////////////////////////////

  const AddProductOfferGroup = (state, banner, banner2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    if (banner) {
      data.append("banner1", banner);
    }
    if (banner2) {
      data.append("banner2", banner2);
    }
    MyAxios.post(`Admin_HomeOfferGroup/Group`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه محصول با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateProductOfferGroup = (state, banner, banner2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (banner) {
      data.append("banner1", banner);
    }
    if (banner2) {
      data.append("banner2", banner2);
    }
    MyAxios.put(`Admin_HomeOfferGroup/Group`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه محصول با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteProductOfferGroup = (OfferID, callback) => {
    const data = new FormData();
    data.append("OfferID", OfferID);
    MyAxios.delete(`Admin_HomeOfferGroup/Group`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("گروه محصول با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  //   /////////////////////////////////////// AddProduct ////////////////////////////////////////

  const AddOfferProduct = (state, callback) => {
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );
    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));
    MyAxios.post(`Admin_HomeOfferGroup/AddOffer`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateOfferProduct = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_HomeOffer/OfferProduct`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اولویت محصول با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteOfferProduct = (OfferProductID, callback) => {
    const data = new FormData();
    data.append("OfferProductID", OfferProductID);
    MyAxios.delete(`Admin_HomeOffer/OfferProduct`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("محصول با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const GetProductsByWord = (search, callback) => {
    MyAxios.get(`Admin_NewOrder/GetProductsByWord?w=${search}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const UpdateOffers = (callback) => {
    MyAxios.post(`Admin_HomeOffer/UpdateOffers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(true);
        enqueueSnackbar("به‌روزرسانی لیست محصول انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const UpdateOffersData = (OfferID, callback) => {
    const data = new FormData();
    data.append("OfferID", OfferID);
    MyAxios.post(`Admin_HomeOffer/UpdateOffersData`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(true);
        enqueueSnackbar("به‌روزرسانی محصولات لیست انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const UpdateOffersList = (state, callback) => {
    MyAxios.post(`Admin_HomeOffer/UpdateOffers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getProductByGroupID = (offerID, groupID, callback2) => {
    ProductOffer(offerID, (callback) => {
      callback2(callback.groups.find((m) => m.id == groupID).products);
    });
  };

  return {
    validate,
    validate2,
    ProductOffer,
    UpdateProductOffer,
    AddProductOffer,
    AddProductOfferGroup,
    UpdateProductOfferGroup,
    deleteProductOfferGroup,
    UpdateOffersList,
    AddOfferProduct,
    UpdateOfferProduct,
    deleteOfferProduct,
    GetProductsByWord,
    UpdateOffers,
    UpdateOffersData,
    validateGroup,
    getProductByGroupID,
  };
}
